/* unplugin-vue-components disabled */import { render } from "./company.vue?vue&type=template&id=11221512&scoped=true"
import script from "./company.vue?vue&type=script&setup=true&lang=js"
export * from "./company.vue?vue&type=script&setup=true&lang=js"

import "./company.vue?vue&type=style&index=0&id=11221512&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11221512"],['__file',"src/components/cards-v2/company/company.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11221512"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11221512', __exports__)) {
    api.reload('11221512', __exports__)
  }
  
  module.hot.accept("./company.vue?vue&type=template&id=11221512&scoped=true", () => {
    api.rerender('11221512', render)
  })

}


export default __exports__